// extracted by mini-css-extract-plugin
module.exports = {"details-title":"MainProductDetails_details-title__WIxMJ","product":"MainProductDetails_product__HHCve","product__row":"MainProductDetails_product__row__z1PTX"};